export enum ProgramStudentStatus {
  REGISTERED = 'REGISTERED',
  STUDYING = 'STUDYING',
  CANCELLED = 'CANCELLED',
  LEFT = 'LEFT',
  COMPLETED = 'COMPLETED',
  GRADUATED = 'GRADUATED',
}

export const getProgramStudentStatusDisplayText = (
  programStudentStatus: ProgramStudentStatus,
) => {
  switch (programStudentStatus) {
    case ProgramStudentStatus.CANCELLED:
      return 'בוטל';
    case ProgramStudentStatus.COMPLETED:
      return 'סיים';
    case ProgramStudentStatus.GRADUATED:
      return 'דופלם';
    case ProgramStudentStatus.LEFT:
      return 'עזב';
    case ProgramStudentStatus.REGISTERED:
      return 'נרשם';
    case ProgramStudentStatus.STUDYING:
      return 'לומד';
  }
};
